export default "__VITE_ASSET__LyQx6uZ___"